module.exports = __webpack_public_path__ + "static/img/map-pin-pickup.f896642.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doorder/map-pin-pickup.png
// module id = hV6J
// module chunks = 0